/**
 * Deciziile pure ale ciornei de notiță — fără DOM, fără crypto, fără store-uri,
 * ca să poată fi testate direct.
 */

/**
 * Ciorna locală se restaurează doar dacă e mai nouă decât ce e pe server
 * (userul încă nu a salvat server-side). Altfel câștigă versiunea de pe server.
 */
export function isDraftNewerThanServer(draftSavedAt: number, serverUpdatedAt: string): boolean {
  return draftSavedAt > new Date(serverUpdatedAt).getTime();
}

/**
 * Există o diferență reală față de versiunea salvată?
 *
 * Flag-ul „dirty" rămâne true și după ce userul tastează și apoi revine la
 * textul inițial. Comparăm cu ce e pe server: fără diferență reală nu salvăm,
 * altfel fiecare ieșire din notiță ar arhiva o versiune identică.
 *
 * `editorHtml` e null când editorul nu (mai) există — atunci nu putem dovedi
 * că nu s-a schimbat nimic, deci nu considerăm notița neschimbată.
 */
export function isUnchangedFromSaved(args: {
  editorHtml: string | null;
  savedHtml: string;
  title: string;
  savedTitle: string | undefined;
}): boolean {
  const { editorHtml, savedHtml, title, savedTitle } = args;
  return editorHtml !== null && editorHtml === savedHtml && title.trim() === savedTitle;
}
